import request from '@/utils/request'
import { automationPlatformHost } from '@/config/host'

// http://gitlab.mobvista.com/playable/video-auto/blob/dev_video_auto/support/doc/video-auto.md

/**
 * getVideoStatus
 * @param {Object} params
 * @param {number} params[].id
 * @return {Promise<any>}
 */
export function getVideoStatus(params) {
  return request({
    url: `${automationPlatformHost}/status`,
    method: 'get',
    params: params
  })
}
